<h2 mat-dialog-title class="mat-headline-small">
	Ungespeicherte Änderungen
</h2>
<p mat-dialog-content class="mat-body-medium">
	Sie Haben Ungespeicherte Änderungen die verloren gehen
</p>
<div mat-dialog-actions>
  <button mat-button (click)="onCancel()">
    Abbrechen
  </button>
  <button mat-button class="button--tertiary" (click)="onConfirm()">
    Bestätigen
  </button>
</div>